import { GoogleMap as ReactGoogleMap } from "@react-google-maps/api";
import React, { ReactNode, useCallback } from "react";
import { useGoogleMaps } from "./GoogleMapProvider";

export type GoogleMapLatLong = { lat: number; lng: number };

// map has unexpected behaviour (camera position jumping around) when input values
// are changed on a re-render, so keep these as static references in memory
const staticOptions = {};
const staticCenter = { lat: 0, lng: 0 };
const staticContainerStyle = { width: "500px", height: "500px" };

export type GoogleMapProps = {
  initialZoom?: number;
  initialCenter?: GoogleMapLatLong;
  initialOptions?: google.maps.MapOptions;
  onLoad?: (map: google.maps.Map) => void;
  containerStyle?: { width: string; height: string };
  children?: ReactNode[] | ReactNode;
};
export const GoogleMap = (props: GoogleMapProps) => {
  const { isLoaded } = useGoogleMaps();

  const onLoad = useCallback((map: google.maps.Map) => {
    props.onLoad?.(map);
  }, []);

  return isLoaded ? (
    <ReactGoogleMap
      mapContainerStyle={props.containerStyle || staticContainerStyle}
      options={props.initialOptions || staticOptions}
      center={props.initialCenter || staticCenter}
      zoom={props.initialZoom || 3}
      onLoad={onLoad}
    >
      {props.children}
    </ReactGoogleMap>
  ) : (
    <></>
  );
};
